import React from 'react';

class ErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            hasError: false,
            error: null,
            errorInfo: null,
            errorCount: 0,
            showLogoutPrompt: false
        };
    }

    static getDerivedStateFromError(error) {
        return { hasError: true };
    }

    componentDidCatch(error, errorInfo) {
        console.error('Error caught by boundary:', error, errorInfo);

        this.setState(prevState => {
            const newCount = prevState.errorCount + 1;

            if (newCount > 10) {
                return {
                    error,
                    errorInfo,
                    errorCount: newCount,
                    showLogoutPrompt: true
                };
            }

            return {
                error,
                errorInfo,
                errorCount: newCount
            };
        });
    }

    handleReset = () => {
        this.setState({
            hasError: false,
            error: null,
            errorInfo: null,
            showLogoutPrompt: false
        });
    };

    handleLogout = () => {
        localStorage.removeItem('jwt');
        localStorage.removeItem('userType');
        sessionStorage.clear();
        window.location.href = '/';
    };

    handleDismissLogoutPrompt = () => {
        this.setState({ showLogoutPrompt: false });
    };

    render() {
        if (this.state.hasError) {
            return (
                <div style={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'center',
                    minHeight: '100vh',
                    padding: '20px',
                    backgroundColor: '#f5f5f5'
                }}>
                    <div style={{
                        backgroundColor: 'white',
                        borderRadius: '8px',
                        padding: '40px',
                        boxShadow: '0 2px 10px rgba(0,0,0,0.1)',
                        maxWidth: '500px',
                        width: '100%',
                        textAlign: 'center'
                    }}>
                        <h1 style={{ color: '#dc3545', marginBottom: '20px' }}>
                            Ups! Coś poszło nie tak
                        </h1>
                        <p style={{ color: '#666', marginBottom: '30px' }}>
                            Wystąpił nieoczekiwany błąd. Przepraszamy za utrudnienia.
                        </p>

                        {this.state.showLogoutPrompt && (
                            <div style={{
                                backgroundColor: '#fff3cd',
                                border: '1px solid #ffc107',
                                borderRadius: '4px',
                                padding: '15px',
                                marginBottom: '20px',
                                textAlign: 'left'
                            }}>
                                <p style={{ margin: '0 0 10px 0', fontWeight: 'bold', color: '#856404' }}>
                                    Wykryto wiele błędów ({this.state.errorCount})
                                </p>
                                <p style={{ margin: '0', fontSize: '14px', color: '#856404' }}>
                                    Może to być problem z sesją. Zalecamy wylogowanie i ponowne zalogowanie.
                                </p>
                                <button
                                    onClick={this.handleLogout}
                                    style={{
                                        marginTop: '10px',
                                        padding: '8px 16px',
                                        backgroundColor: '#ffc107',
                                        color: '#000',
                                        border: 'none',
                                        borderRadius: '4px',
                                        cursor: 'pointer',
                                        fontSize: '14px',
                                        fontWeight: 'bold'
                                    }}
                                >
                                    Wyloguj i zaloguj ponownie
                                </button>
                                <button
                                    onClick={this.handleDismissLogoutPrompt}
                                    style={{
                                        marginTop: '10px',
                                        marginLeft: '10px',
                                        padding: '8px 16px',
                                        backgroundColor: 'transparent',
                                        color: '#856404',
                                        border: '1px solid #ffc107',
                                        borderRadius: '4px',
                                        cursor: 'pointer',
                                        fontSize: '14px'
                                    }}
                                >
                                    Pomiń
                                </button>
                            </div>
                        )}

                        {process.env.NODE_ENV === 'development' && this.state.error && (
                            <details style={{
                                textAlign: 'left',
                                marginBottom: '20px',
                                padding: '10px',
                                backgroundColor: '#f8f9fa',
                                borderRadius: '4px'
                            }}>
                                <summary style={{ cursor: 'pointer', color: '#666' }}>
                                    Szczegóły błędu (tylko w trybie deweloperskim)
                                </summary>
                                <pre style={{
                                    marginTop: '10px',
                                    fontSize: '12px',
                                    overflow: 'auto'
                                }}>
                                    {this.state.error.toString()}
                                    {this.state.errorInfo && this.state.errorInfo.componentStack}
                                </pre>
                            </details>
                        )}

                        <div style={{ display: 'flex', gap: '10px', justifyContent: 'center', flexWrap: 'wrap' }}>
                            <button
                                onClick={this.handleReset}
                                style={{
                                    padding: '10px 20px',
                                    backgroundColor: '#007bff',
                                    color: 'white',
                                    border: 'none',
                                    borderRadius: '4px',
                                    cursor: 'pointer',
                                    fontSize: '16px'
                                }}
                            >
                                Spróbuj ponownie
                            </button>
                            <button
                                onClick={() => window.location.reload()}
                                style={{
                                    padding: '10px 20px',
                                    backgroundColor: '#28a745',
                                    color: 'white',
                                    border: 'none',
                                    borderRadius: '4px',
                                    cursor: 'pointer',
                                    fontSize: '16px'
                                }}
                            >
                                Odśwież stronę
                            </button>
                            <button
                                onClick={this.handleLogout}
                                style={{
                                    padding: '10px 20px',
                                    backgroundColor: '#6c757d',
                                    color: 'white',
                                    border: 'none',
                                    borderRadius: '4px',
                                    cursor: 'pointer',
                                    fontSize: '16px'
                                }}
                            >
                                Wyloguj się
                            </button>
                        </div>
                    </div>
                </div>
            );
        }

        return this.props.children;
    }
}

export default ErrorBoundary;